<!-- Footer -->
<footer class="analysis-footer">
  <div class="footer-inner">
    <div class="footer-left">
      <div class="footer-title">Disinformation Analysis</div>
      <div class="footer-subtitle">
        This tool provides probabilistic text classification and narrative matching. It is not a factual verification service.
      </div>
    </div>

    <div class="footer-right">
      <div class="footer-badges">
        <span class="footer-pill">Knowledge Base: EUvsDisinfo</span>
        <span class="footer-pill">Model: GPT5.1</span>
        <span class="footer-pill footer-pill-muted">Research Prototype</span>
      </div>
      <div class="footer-meta">
        © {{ currentYear }} · Built for academic research
      </div>
    </div>
  </div>
</footer>
